module.exports = __webpack_public_path__ + "static/img/spinner.74e8fcb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/spinner.gif
// module id = K7zp
// module chunks = 1